// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportReviewerEntity from './entities/report-reviewer.json';
import reportReviewerMenu from '../pages/report-reviewer/menu.json';
import reportReviewerFullForm from '../pages/report-reviewer/forms/full.json';
import reportReviewerContextForm from '../pages/report-reviewer/forms/context.json';
import reportReviewerMiniForm from '../pages/report-reviewer/forms/mini.json';
import reportReviewerLookupForm from '../pages/report-reviewer/forms/lookup.json';
import reportReviewerTableView from '../pages/report-reviewer/views/table.json';
import reportReviewerCardsView from '../pages/report-reviewer/views/cards.json';
import reportReviewerCalendarView from '../pages/report-reviewer/views/calendar.json';
import reportReviewerDashboardView from '../pages/report-reviewer/views/dashboard.json';

/** Тип запису «Рецензент звіту» зі сторінками пакета: меню, форми та подання з pages/report-reviewer/. */
export const reportReviewerDefinition: IRecordTypeDefinition = {
  ...reportReviewerEntity,
  views: assembleViewSet({
      table: reportReviewerTableView,
      cards: reportReviewerCardsView,
      calendar: reportReviewerCalendarView,
      dashboard: reportReviewerDashboardView,
  }),
  form: reportReviewerFullForm,
  forms: { full: reportReviewerFullForm, context: reportReviewerContextForm, mini: reportReviewerMiniForm, lookup: reportReviewerLookupForm },
  menu: reportReviewerMenu,
} as IRecordTypeDefinition;
